import { render, staticRenderFns } from "./VListGroup.vue?vue&type=template&id=325b06ef&scoped=true&"
import script from "./VListGroup.vue?vue&type=script&lang=ts&"
export * from "./VListGroup.vue?vue&type=script&lang=ts&"
import style0 from "./VListGroup.vue?vue&type=style&index=0&id=325b06ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325b06ef",
  null
  
)

export default component.exports